import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/_services/auth/auth.service';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';

/**
 * Guard de ruta que protege el acceso a las secciones privadas de la aplicación.
 *
 * Verifica que exista una sesión válida antes de permitir la navegación:
 * comprueba que el usuario esté autenticado, que su sesión siga activa y que
 * disponga de autorizaciones almacenadas. Si alguna condición falla, redirige
 * al login o cierra la sesión.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
		private router: Router,
		private authService: AuthService,
    private localStorageService: LocalStorageService
	) { }

  /**
   * Determina si se permite la activación de la ruta solicitada.
   *
   * Redirige al login si el usuario no ha iniciado sesión y cierra la sesión
   * si esta ha expirado o si no existen autorizaciones almacenadas.
   * @returns `true` si la sesión es válida y se permite el acceso; `false` en caso contrario.
   */
  canActivate() {
    // If the user is not logged in we'll send them back to the home page
    if (!this.authService.isLogged()) {
      this.router.navigate(['/login']);
      return false;
    }
    // If the user's session expired returns to the login
    if (!this.authService.isSessionActive()) {
      this.authService.logout();
      return false;
    }
    // If the user doesn't have authorizations returns to the login
    if (!this.localStorageService.getData('authorizations')) {
      this.authService.logout();
      return false;
    }
    return true;
  }
}
